import { Language } from '../shared/models/app.model';

// Microsoft Azure Speech-to-Text supported languages
export const SUPPORTED_LANGUAGES: Language[] = [
  /* eslint-disable max-len */
  {
    languageCode: 'da-DK',
    isVerified: true,
    exonym: 'Danish (Denmark)',
    language: 'Danish',
    iconClass: 'fi fi-dk',
  },
  {
    languageCode: 'de-CH',
    isVerified: true,
    exonym: 'German (Switzerland)',
    language: 'Deutsche (Schweiz)',
    iconClass: 'fi fi-ch',
  },
  {
    languageCode: 'de-DE',
    isVerified: true,
    exonym: 'German (Germany)',
    language: 'Deutsch',
    iconClass: 'fi fi-de',
  },
  {
    languageCode: 'en-GB',
    isVerified: true,
    exonym: 'English (United Kingdom)',
    language: 'English (UK)',
    iconClass: 'fi fi-gb',
  },
  {
    languageCode: 'en-US',
    isVerified: true,
    exonym: 'English (United States)',
    language: 'English (US)',
    iconClass: 'fi fi-us',
  },
  {
    languageCode: 'es-ES',
    isVerified: true,
    exonym: 'Spanish (Spain)',
    language: 'Español',
    iconClass: 'fi fi-es',
  },
  {
    languageCode: 'fr-FR',
    isVerified: true,
    exonym: 'French (France)',
    language: 'Français',
    iconClass: 'fi fi-fr',
  },
  {
    languageCode: 'it-IT',
    isVerified: true,
    exonym: 'Italian (Italy)',
    language: 'Italiano',
    iconClass: 'fi fi-it',
  },
  {
    languageCode: 'nl-NL',
    isVerified: true,
    exonym: 'Dutch (Netherlands)',
    language: 'Nederlands',
    iconClass: 'fi fi-nl',
  },
  {
    languageCode: 'pt-PT',
    isVerified: true,
    exonym: 'Portuguese (Portugal)',
    language: 'Português',
    iconClass: 'fi fi-pt',
  },
  {
    languageCode: 'uk-UA',
    isVerified: true,
    exonym: 'Ukrainian (Ukraine)',
    language: 'Українська',
    iconClass: 'fi fi-ua',
  },
  
  // All Azure STT supported languages (unverified by default)
  {
    languageCode: 'af-ZA',
    isVerified: false,
    exonym: 'Afrikaans (South Africa)',
    language: 'Afrikaans',
    iconClass: 'fi fi-za',
  },
  {
    languageCode: 'am-ET',
    isVerified: false,
    exonym: 'Amharic (Ethiopia)',
    language: 'አማርኛ',
    iconClass: 'fi fi-et',
  },
  {
    languageCode: 'ar-AE',
    isVerified: false,
    exonym: 'Arabic (United Arab Emirates)',
    language: 'العربية (UAE)',
    iconClass: 'fi fi-ae',
  },
  {
    languageCode: 'ar-BH',
    isVerified: false,
    exonym: 'Arabic (Bahrain)',
    language: 'العربية (BH)',
    iconClass: 'fi fi-bh',
  },
  {
    languageCode: 'ar-DZ',
    isVerified: false,
    exonym: 'Arabic (Algeria)',
    language: 'العربية (DZ)',
    iconClass: 'fi fi-dz',
  },
  {
    languageCode: 'ar-EG',
    isVerified: false,
    exonym: 'Arabic (Egypt)',
    language: 'العربية (EG)',
    iconClass: 'fi fi-eg',
  },
  {
    languageCode: 'ar-IL',
    isVerified: false,
    exonym: 'Arabic (Israel)',
    language: 'العربية (IL)',
    iconClass: 'fi fi-il',
  },
  {
    languageCode: 'ar-IQ',
    isVerified: false,
    exonym: 'Arabic (Iraq)',
    language: 'العربية (IQ)',
    iconClass: 'fi fi-iq',
  },
  {
    languageCode: 'ar-JO',
    isVerified: false,
    exonym: 'Arabic (Jordan)',
    language: 'العربية (JO)',
    iconClass: 'fi fi-jo',
  },
  {
    languageCode: 'ar-KW',
    isVerified: false,
    exonym: 'Arabic (Kuwait)',
    language: 'العربية (KW)',
    iconClass: 'fi fi-kw',
  },
  {
    languageCode: 'ar-LB',
    isVerified: false,
    exonym: 'Arabic (Lebanon)',
    language: 'العربية (LB)',
    iconClass: 'fi fi-lb',
  },
  {
    languageCode: 'ar-LY',
    isVerified: false,
    exonym: 'Arabic (Libya)',
    language: 'العربية (LY)',
    iconClass: 'fi fi-ly',
  },
  {
    languageCode: 'ar-MA',
    isVerified: false,
    exonym: 'Arabic (Morocco)',
    language: 'العربية (MA)',
    iconClass: 'fi fi-ma',
  },
  {
    languageCode: 'ar-OM',
    isVerified: false,
    exonym: 'Arabic (Oman)',
    language: 'العربية (OM)',
    iconClass: 'fi fi-om',
  },
  {
    languageCode: 'ar-PS',
    isVerified: false,
    exonym: 'Arabic (Palestinian Authority)',
    language: 'العربية (PS)',
    iconClass: 'fi fi-ps',
  },
  {
    languageCode: 'ar-QA',
    isVerified: false,
    exonym: 'Arabic (Qatar)',
    language: 'العربية (QA)',
    iconClass: 'fi fi-qa',
  },
  {
    languageCode: 'ar-SA',
    isVerified: false,
    exonym: 'Arabic (Saudi Arabia)',
    language: 'العربية (SA)',
    iconClass: 'fi fi-sa',
  },
  {
    languageCode: 'ar-SY',
    isVerified: false,
    exonym: 'Arabic (Syria)',
    language: 'العربية (SY)',
    iconClass: 'fi fi-sy',
  },
  {
    languageCode: 'ar-TN',
    isVerified: false,
    exonym: 'Arabic (Tunisia)',
    language: 'العربية (TN)',
    iconClass: 'fi fi-tn',
  },
  {
    languageCode: 'ar-YE',
    isVerified: false,
    exonym: 'Arabic (Yemen)',
    language: 'العربية (YE)',
    iconClass: 'fi fi-ye',
  },
  // {
  //   languageCode: 'as-IN',
  //   isVerified: false,
  //   exonym: 'Assamese (India)',
  //   language: 'অসমীয়া',
  //   iconClass: 'fi fi-in',
  // },
  {
    languageCode: 'az-AZ',
    isVerified: false,
    exonym: 'Azerbaijani (Latin, Azerbaijan)',
    language: 'azərbaycan dili',
    iconClass: 'fi fi-az',
  },
  {
    languageCode: 'bg-BG',
    isVerified: false,
    exonym: 'Bulgarian (Bulgaria)',
    language: 'български език',
    iconClass: 'fi fi-bg',
  },
  {
    languageCode: 'bn-IN',
    isVerified: false,
    exonym: 'Bengali (India)',
    language: 'বাংলা',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'bn-BD',
    isVerified: false,
    exonym: 'Bengali (Bangladesh)',
    language: 'বাংলা (BD)',
    iconClass: 'fi fi-bd',
  },
  {
    languageCode: 'bs-BA',
    isVerified: false,
    exonym: 'Bosnian (Bosnia and Herzegovina)',
    language: 'bosanski',
    iconClass: 'fi fi-ba',
  },
  {
    languageCode: 'ca-ES',
    isVerified: false,
    exonym: 'Catalan',
    language: 'català',
    iconClass: 'fi fi-es-ct',
  },
  {
    languageCode: 'cs-CZ',
    isVerified: false,
    exonym: 'Czech (Czechia)',
    language: 'čeština',
    iconClass: 'fi fi-cz',
  },
  {
    languageCode: 'cy-GB',
    isVerified: false,
    exonym: 'Welsh (United Kingdom)',
    language: 'Cymraeg',
    iconClass: 'fi fi-gb-wls',
  },
  {
    languageCode: 'de-AT',
    isVerified: false,
    exonym: 'German (Austria)',
    language: 'Deutsch (AT)',
    iconClass: 'fi fi-at',
  },
  {
    languageCode: 'el-GR',
    isVerified: false,
    exonym: 'Greek (Greece)',
    language: 'Ελληνικά',
    iconClass: 'fi fi-gr',
  },
  {
    languageCode: 'en-AU',
    isVerified: false,
    exonym: 'English (Australia)',
    language: 'English (AU)',
    iconClass: 'fi fi-au',
  },
  {
    languageCode: 'en-CA',
    isVerified: false,
    exonym: 'English (Canada)',
    language: 'English (CA)',
    iconClass: 'fi fi-ca',
  },
  {
    languageCode: 'en-GH',
    isVerified: false,
    exonym: 'English (Ghana)',
    language: 'English (GH)',
    iconClass: 'fi fi-gh',
  },
  {
    languageCode: 'en-HK',
    isVerified: false,
    exonym: 'English (Hong Kong SAR)',
    language: 'English (HK)',
    iconClass: 'fi fi-hk',
  },
  {
    languageCode: 'en-IE',
    isVerified: false,
    exonym: 'English (Ireland)',
    language: 'English (IE)',
    iconClass: 'fi fi-ie',
  },
  {
    languageCode: 'en-IN',
    isVerified: false,
    exonym: 'English (India)',
    language: 'English (IN)',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'en-KE',
    isVerified: false,
    exonym: 'English (Kenya)',
    language: 'English (KE)',
    iconClass: 'fi fi-ke',
  },
  {
    languageCode: 'en-NG',
    isVerified: false,
    exonym: 'English (Nigeria)',
    language: 'English (NG)',
    iconClass: 'fi fi-ng',
  },
  {
    languageCode: 'en-NZ',
    isVerified: false,
    exonym: 'English (New Zealand)',
    language: 'English (NZ)',
    iconClass: 'fi fi-nz',
  },
  {
    languageCode: 'en-PK',
    isVerified: false,
    exonym: 'English (Pakistan)',
    language: 'English (PK)',
    iconClass: 'fi fi-pk',
  },
  {
    languageCode: 'en-PH',
    isVerified: false,
    exonym: 'English (Philippines)',
    language: 'English (PH)',
    iconClass: 'fi fi-ph',
  },
  {
    languageCode: 'en-SG',
    isVerified: false,
    exonym: 'English (Singapore)',
    language: 'English (SG)',
    iconClass: 'fi fi-sg',
  },
  {
    languageCode: 'en-TZ',
    isVerified: false,
    exonym: 'English (Tanzania)',
    language: 'English (TZ)',
    iconClass: 'fi fi-tz',
  },
  {
    languageCode: 'en-ZA',
    isVerified: false,
    exonym: 'English (South Africa)',
    language: 'English (ZA)',
    iconClass: 'fi fi-za',
  },
  {
    languageCode: 'es-AR',
    isVerified: false,
    exonym: 'Spanish (Argentina)',
    language: 'Español (AR)',
    iconClass: 'fi fi-ar',
  },
  {
    languageCode: 'es-BO',
    isVerified: false,
    exonym: 'Spanish (Bolivia)',
    language: 'Español (BO)',
    iconClass: 'fi fi-bo',
  },
  {
    languageCode: 'es-CL',
    isVerified: false,
    exonym: 'Spanish (Chile)',
    language: 'Español (CL)',
    iconClass: 'fi fi-cl',
  },
  {
    languageCode: 'es-CO',
    isVerified: false,
    exonym: 'Spanish (Colombia)',
    language: 'Español (CO)',
    iconClass: 'fi fi-co',
  },
  {
    languageCode: 'es-CR',
    isVerified: false,
    exonym: 'Spanish (Costa Rica)',
    language: 'Español (CR)',
    iconClass: 'fi fi-cr',
  },
  {
    languageCode: 'es-CU',
    isVerified: false,
    exonym: 'Spanish (Cuba)',
    language: 'Español (CU)',
    iconClass: 'fi fi-cu',
  },
  {
    languageCode: 'es-DO',
    isVerified: false,
    exonym: 'Spanish (Dominican Republic)',
    language: 'Español (DO)',
    iconClass: 'fi fi-do',
  },
  {
    languageCode: 'es-EC',
    isVerified: false,
    exonym: 'Spanish (Ecuador)',
    language: 'Español (EC)',
    iconClass: 'fi fi-ec',
  },
  {
    languageCode: 'es-GQ',
    isVerified: false,
    exonym: 'Spanish (Equatorial Guinea)',
    language: 'Español (GQ)',
    iconClass: 'fi fi-gq',
  },
  {
    languageCode: 'es-GT',
    isVerified: false,
    exonym: 'Spanish (Guatemala)',
    language: 'Español (GT)',
    iconClass: 'fi fi-gt',
  },
  {
    languageCode: 'es-HN',
    isVerified: false,
    exonym: 'Spanish (Honduras)',
    language: 'Español (HN)',
    iconClass: 'fi fi-hn',
  },
  {
    languageCode: 'es-MX',
    isVerified: false,
    exonym: 'Spanish (Mexico)',
    language: 'Español (MX)',
    iconClass: 'fi fi-mx',
  },
  {
    languageCode: 'es-NI',
    isVerified: false,
    exonym: 'Spanish (Nicaragua)',
    language: 'Español (NI)',
    iconClass: 'fi fi-ni',
  },
  {
    languageCode: 'es-PA',
    isVerified: false,
    exonym: 'Spanish (Panama)',
    language: 'Español (PA)',
    iconClass: 'fi fi-pa',
  },
  {
    languageCode: 'es-PE',
    isVerified: false,
    exonym: 'Spanish (Peru)',
    language: 'Español (PE)',
    iconClass: 'fi fi-pe',
  },
  {
    languageCode: 'es-PR',
    isVerified: false,
    exonym: 'Spanish (Puerto Rico)',
    language: 'Español (PR)',
    iconClass: 'fi fi-pr',
  },
  {
    languageCode: 'es-PY',
    isVerified: false,
    exonym: 'Spanish (Paraguay)',
    language: 'Español (PY)',
    iconClass: 'fi fi-py',
  },
  {
    languageCode: 'es-SV',
    isVerified: false,
    exonym: 'Spanish (El Salvador)',
    language: 'Español (SV)',
    iconClass: 'fi fi-sv',
  },
  {
    languageCode: 'es-US',
    isVerified: false,
    exonym: 'Spanish (United States)',
    language: 'Español (US)',
    iconClass: 'fi fi-us',
  },
  {
    languageCode: 'es-UY',
    isVerified: false,
    exonym: 'Spanish (Uruguay)',
    language: 'Español (UY)',
    iconClass: 'fi fi-uy',
  },
  {
    languageCode: 'es-VE',
    isVerified: false,
    exonym: 'Spanish (Venezuela)',
    language: 'Español (VE)',
    iconClass: 'fi fi-ve',
  },
  {
    languageCode: 'et-EE',
    isVerified: false,
    exonym: 'Estonian (Estonia)',
    language: 'eesti',
    iconClass: 'fi fi-ee',
  },
  {
    languageCode: 'eu-ES',
    isVerified: false,
    exonym: 'Basque',
    language: 'euskera',
    iconClass: 'fi fi-es-pv',
  },
  {
    languageCode: 'fa-IR',
    isVerified: false,
    exonym: 'Persian (Iran)',
    language: 'فارسی',
    iconClass: 'fi fi-ir',
  },
  {
    languageCode: 'fi-FI',
    isVerified: false,
    exonym: 'Finnish (Finland)',
    language: 'suomi',
    iconClass: 'fi fi-fi',
  },
  {
    languageCode: 'fil-PH',
    isVerified: false,
    exonym: 'Filipino (Philippines)',
    language: 'Filipino',
    iconClass: 'fi fi-ph',
  },
  {
    languageCode: 'fr-BE',
    isVerified: false,
    exonym: 'French (Belgium)',
    language: 'Français (BE)',
    iconClass: 'fi fi-be',
  },
  {
    languageCode: 'fr-CA',
    isVerified: false,
    exonym: 'French (Canada)',
    language: 'Français (CA)',
    iconClass: 'fi fi-ca',
  },
  {
    languageCode: 'fr-CH',
    isVerified: false,
    exonym: 'French (Switzerland)',
    language: 'Français (CH)',
    iconClass: 'fi fi-ch',
  },
  {
    languageCode: 'ga-IE',
    isVerified: false,
    exonym: 'Irish (Ireland)',
    language: 'Gaeilge',
    iconClass: 'fi fi-ie',
  },
  {
    languageCode: 'gl-ES',
    isVerified: false,
    exonym: 'Galician',
    language: 'galego',
    iconClass: 'fi fi-es-ga',
  },
  {
    languageCode: 'gu-IN',
    isVerified: false,
    exonym: 'Gujarati (India)',
    language: 'ગુજરાતી',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'he-IL',
    isVerified: false,
    exonym: 'Hebrew (Israel)',
    language: 'עברית',
    iconClass: 'fi fi-il',
  },
  {
    languageCode: 'hi-IN',
    isVerified: false,
    exonym: 'Hindi (India)',
    language: 'हिन्दी',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'hr-HR',
    isVerified: false,
    exonym: 'Croatian (Croatia)',
    language: 'hrvatski',
    iconClass: 'fi fi-hr',
  },
  {
    languageCode: 'hu-HU',
    isVerified: false,
    exonym: 'Hungarian (Hungary)',
    language: 'magyar',
    iconClass: 'fi fi-hu',
  },
  {
    languageCode: 'hy-AM',
    isVerified: false,
    exonym: 'Armenian (Armenia)',
    language: 'Հայերեն',
    iconClass: 'fi fi-am',
  },
  {
    languageCode: 'id-ID',
    isVerified: false,
    exonym: 'Indonesian (Indonesia)',
    language: 'Bahasa Indonesia',
    iconClass: 'fi fi-id',
  },
  {
    languageCode: 'is-IS',
    isVerified: false,
    exonym: 'Icelandic (Iceland)',
    language: 'íslenska',
    iconClass: 'fi fi-is',
  },
  {
    languageCode: 'it-CH',
    isVerified: false,
    exonym: 'Italian (Switzerland)',
    language: 'italiano (CH)',
    iconClass: 'fi fi-ch',
  },
  {
    languageCode: 'ja-JP',
    isVerified: false,
    exonym: 'Japanese (Japan)',
    language: '日本語',
    iconClass: 'fi fi-jp',
  },
  {
    languageCode: 'jv-ID',
    isVerified: false,
    exonym: 'Javanese (Latin, Indonesia)',
    language: 'basa Jawa',
    iconClass: 'fi fi-id',
  },
  {
    languageCode: 'ka-GE',
    isVerified: false,
    exonym: 'Georgian (Georgia)',
    language: 'ქართული',
    iconClass: 'fi fi-ge',
  },
  {
    languageCode: 'kk-KZ',
    isVerified: false,
    exonym: 'Kazakh (Kazakhstan)',
    language: 'қазақ тілі',
    iconClass: 'fi fi-kz',
  },
  {
    languageCode: 'km-KH',
    isVerified: false,
    exonym: 'Khmer (Cambodia)',
    language: 'ភាសាខ្មែរ',
    iconClass: 'fi fi-kh',
  },
  {
    languageCode: 'kn-IN',
    isVerified: false,
    exonym: 'Kannada (India)',
    language: 'ಕನ್ನಡ',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'ko-KR',
    isVerified: false,
    exonym: 'Korean (Korea)',
    language: '한국어',
    iconClass: 'fi fi-kr',
  },
  {
    languageCode: 'lo-LA',
    isVerified: false,
    exonym: 'Lao (Laos)',
    language: 'ພາສາລາວ',
    iconClass: 'fi fi-la',
  },
  {
    languageCode: 'lt-LT',
    isVerified: false,
    exonym: 'Lithuanian (Lithuania)',
    language: 'lietuvių kalba',
    iconClass: 'fi fi-lt',
  },
  {
    languageCode: 'lv-LV',
    isVerified: false,
    exonym: 'Latvian (Latvia)',
    language: 'latviešu valoda',
    iconClass: 'fi fi-lv',
  },
  {
    languageCode: 'mk-MK',
    isVerified: false,
    exonym: 'Macedonian (North Macedonia)',
    language: 'македонски јазик',
    iconClass: 'fi fi-mk',
  },
  {
    languageCode: 'ml-IN',
    isVerified: false,
    exonym: 'Malayalam (India)',
    language: 'മലയാളം',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'mn-MN',
    isVerified: false,
    exonym: 'Mongolian (Mongolia)',
    language: 'монгол',
    iconClass: 'fi fi-mn',
  },
  {
    languageCode: 'mr-IN',
    isVerified: false,
    exonym: 'Marathi (India)',
    language: 'मराठी',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'ms-MY',
    isVerified: false,
    exonym: 'Malay (Malaysia)',
    language: 'bahasa Melayu',
    iconClass: 'fi fi-my',
  },
  {
    languageCode: 'mt-MT',
    isVerified: false,
    exonym: 'Maltese (Malta)',
    language: 'Malti',
    iconClass: 'fi fi-mt',
  },
  {
    languageCode: 'my-MM',
    isVerified: false,
    exonym: 'Burmese (Myanmar)',
    language: 'ဗမာစာ',
    iconClass: 'fi fi-mm',
  },
  {
    languageCode: 'nb-NO',
    isVerified: false,
    exonym: 'Norwegian Bokmål (Norway)',
    language: 'norsk bokmål',
    iconClass: 'fi fi-no',
  },
  {
    languageCode: 'no-NO',
    isVerified: false,
    exonym: 'Norwegian (Norway)',
    language: 'norsk',
    iconClass: 'fi fi-no',
  },
  {
    languageCode: 'ne-NP',
    isVerified: false,
    exonym: 'Nepali (Nepal)',
    language: 'नेपाली',
    iconClass: 'fi fi-np',
  },
  {
    languageCode: 'nl-BE',
    isVerified: false,
    exonym: 'Dutch (Belgium)',
    language: 'Nederlands (BE)',
    iconClass: 'fi fi-be',
  },
  // {
  //   languageCode: 'or-IN',
  //   isVerified: false,
  //   exonym: 'Odia (India)',
  //   language: 'ଓଡ଼ିଆ',
  //   iconClass: 'fi fi-in',
  // },
  // {
  //   languageCode: 'pa-IN',
  //   isVerified: false,
  //   exonym: 'Punjabi (India)',
  //   language: 'ਪੰਜਾਬੀ',
  //   iconClass: 'fi fi-in',
  // },
  {
    languageCode: 'pl-PL',
    isVerified: false,
    exonym: 'Polish (Poland)',
    language: 'polski',
    iconClass: 'fi fi-pl',
  },
  {
    languageCode: 'ps-AF',
    isVerified: false,
    exonym: 'Pashto (Afghanistan)',
    language: 'پښتو',
    iconClass: 'fi fi-af',
  },
  {
    languageCode: 'pt-BR',
    isVerified: false,
    exonym: 'Portuguese (Brazil)',
    language: 'português (BR)',
    iconClass: 'fi fi-br',
  },
  {
    languageCode: 'ro-RO',
    isVerified: false,
    exonym: 'Romanian (Romania)',
    language: 'română',
    iconClass: 'fi fi-ro',
  },
  {
    languageCode: 'ru-RU',
    isVerified: false,
    exonym: 'Russian (Russia)',
    language: 'русский',
    iconClass: 'fi fi-ru',
  },
  {
    languageCode: 'si-LK',
    isVerified: false,
    exonym: 'Sinhala (Sri Lanka)',
    language: 'සිංහල',
    iconClass: 'fi fi-lk',
  },
  {
    languageCode: 'sk-SK',
    isVerified: false,
    exonym: 'Slovak (Slovakia)',
    language: 'slovenčina',
    iconClass: 'fi fi-sk',
  },
  {
    languageCode: 'sl-SI',
    isVerified: false,
    exonym: 'Slovenian (Slovenia)',
    language: 'slovenščina',
    iconClass: 'fi fi-si',
  },
  {
    languageCode: 'so-SO',
    isVerified: false,
    exonym: 'Somali (Somalia)',
    language: 'Soomaali',
    iconClass: 'fi fi-so',
  },
  {
    languageCode: 'sq-AL',
    isVerified: false,
    exonym: 'Albanian (Albania)',
    language: 'shqip',
    iconClass: 'fi fi-al',
  },
  {
    languageCode: 'sr-RS',
    isVerified: false,
    exonym: 'Serbian (Cyrillic, Serbia)',
    language: 'српски',
    iconClass: 'fi fi-rs',
  },
  {
    languageCode: 'sv-SE',
    isVerified: false,
    exonym: 'Swedish (Sweden)',
    language: 'svenska',
    iconClass: 'fi fi-se',
  },
  {
    languageCode: 'sw-KE',
    isVerified: false,
    exonym: 'Kiswahili (Kenya)',
    language: 'Kiswahili (KE)',
    iconClass: 'fi fi-ke',
  },
  {
    languageCode: 'sw-TZ',
    isVerified: false,
    exonym: 'Kiswahili (Tanzania)',
    language: 'Kiswahili (TZ)',
    iconClass: 'fi fi-tz',
  },
  {
    languageCode: 'ta-IN',
    isVerified: false,
    exonym: 'Tamil (India)',
    language: 'தமிழ்',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'ta-LK',
    isVerified: false,
    exonym: 'Tamil (Sri Lanka)',
    language: 'தமிழ் (LK)',
    iconClass: 'fi fi-lk',
  },
  {
    languageCode: 'ta-MY',
    isVerified: false,
    exonym: 'Tamil (Malaysia)',
    language: 'தமிழ் (MY)',
    iconClass: 'fi fi-my',
  },
  {
    languageCode: 'ta-SG',
    isVerified: false,
    exonym: 'Tamil (Singapore)',
    language: 'தமிழ் (SG)',
    iconClass: 'fi fi-sg',
  },
  {
    languageCode: 'te-IN',
    isVerified: false,
    exonym: 'Telugu (India)',
    language: 'తెలుగు',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'th-TH',
    isVerified: false,
    exonym: 'Thai (Thailand)',
    language: 'ไทย',
    iconClass: 'fi fi-th',
  },
  {
    languageCode: 'tr-TR',
    isVerified: false,
    exonym: 'Turkish (Türkiye)',
    language: 'Türkçe',
    iconClass: 'fi fi-tr',
  },
  {
    languageCode: 'ur-IN',
    isVerified: false,
    exonym: 'Urdu (India)',
    language: 'اردو (IN)',
    iconClass: 'fi fi-in',
  },
  {
    languageCode: 'ur-PK',
    isVerified: false,
    exonym: 'Urdu (Pakistan)',
    language: 'اردو (PK)',
    iconClass: 'fi fi-pk',
  },
  {
    languageCode: 'uz-UZ',
    isVerified: false,
    exonym: 'Uzbek (Latin, Uzbekistan)',
    language: 'oʻzbek',
    iconClass: 'fi fi-uz',
  },
  {
    languageCode: 'vi-VN',
    isVerified: false,
    exonym: 'Vietnamese (Vietnam)',
    language: 'Tiếng Việt',
    iconClass: 'fi fi-vn',
  },
  {
    languageCode: 'yue-CN',
    isVerified: false,
    exonym: 'Chinese (Cantonese, Simplified)',
    language: '粵語',
    iconClass: 'fi fi-cn',
  },
  {
    languageCode: 'yue-Hant-HK',
    isVerified: false,
    exonym: 'Cantonese (Traditional)',
    language: '粵語 (繁體)',
    iconClass: 'fi fi-hk',
  },
  {
    languageCode: 'zh-CN',
    isVerified: false,
    exonym: 'Chinese (Mandarin, Simplified)',
    language: '中文 (简体)',
    iconClass: 'fi fi-cn',
  },
  {
    languageCode: 'zh-HK',
    isVerified: false,
    exonym: 'Chinese (Cantonese, Traditional)',
    language: '中文 (繁體)',
    iconClass: 'fi fi-hk',
  },
  {
    languageCode: 'zh-TW',
    isVerified: false,
    exonym: 'Chinese (Taiwanese Mandarin, Traditional)',
    language: '中文 (台灣)',
    iconClass: 'fi fi-tw',
  },
  {
    languageCode: 'zu-ZA',
    isVerified: false,
    exonym: 'isiZulu (South Africa)',
    language: 'isiZulu',
    iconClass: 'fi fi-za',
  },
  /* eslint-enable max-len */
];